
export const SUBJECT_OPTIONS = [
  'คณิตศาสตร์',
  'ชีววิทยา',
  'สังคม',
  'วิทยาศาสตร์',
  'อังกฤษ',
  'ภาษาไทย',
  'ฟิสิกส์',
  'เคมี',
  'ภาษาจีน'
];
